import React from 'react';
import { SectionCta } from './SectionCta';
import { tools, caseQuestions } from '../data/content';
export function Tools() {
  return <section className="bg-navy-950 px-5 py-16 sm:py-24" aria-labelledby="tools-title" data-id="element-325" data-mp="1lfvv850z3orz">
      <div className="mx-auto max-w-5xl" data-id="element-326" data-mp="17fuuqqomejd1">
        <p className="text-center text-sm font-bold uppercase tracking-widest text-radar" data-id="element-327" data-mp="1cdmpdsgngjkx">Plus</p>
        <h2 id="tools-title" className="mt-2 text-center font-display text-4xl font-bold uppercase leading-tight text-white sm:text-5xl" data-id="element-328" data-mp="203794dkmnkv9">
          You'll get immediate access to
        </h2>

        <ul className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-329" data-mp="1qdxi711is88q">
          {tools.map(({
          icon: Icon,
          title,
          text
        }) => <li key={title} className="flex flex-col rounded-2xl bg-white/[0.05] p-6 ring-1 ring-white/10" data-id="element-330" data-mp="1vb7catzut82w">
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-radar" data-id="element-331" data-mp="2j0i9k1hzwkca">
                <Icon className="h-6 w-6 text-navy-950" aria-hidden="true" data-id="element-332" data-mp="2nucm8kz6nz1v" />
              </span>
              <h3 className="mt-4 font-display text-xl font-semibold uppercase leading-tight text-white" data-id="element-333" data-mp="2p276w4ag5rmn">{title}</h3>
              <p className="mt-2 text-[16px] leading-relaxed text-white/75" data-id="element-334" data-mp="2kxzg81kfi1ls">{text}</p>
            </li>)}
        </ul>

        <div className="mx-auto mt-16 max-w-2xl" data-id="element-335" data-mp="2u0qs22h7uzdy">
          <h3 className="text-center font-display text-3xl font-bold uppercase leading-tight text-white" data-id="element-336" data-mp="2tz7e4ij190fc">
            Whatever implant case walks into your practice…
          </h3>
          <p className="mt-3 text-center text-lg text-white/80" data-id="element-337" data-mp="33piiu7ajjdna">You'll have a structured system for asking:</p>
          <ul className="mt-6 space-y-3" data-id="element-338" data-mp="3hp1rd179kr04">
            {caseQuestions.map(q => <li key={q} className="rounded-2xl border-l-4 border-radar bg-white/[0.06] px-5 py-4 text-lg font-semibold leading-snug text-white" data-id="element-339" data-mp="3csbawcrjrte6">
                {q}
              </li>)}
          </ul>
          <p className="mt-8 text-center text-lg font-semibold text-radar" data-id="element-340" data-mp="3ifgmkj7jny5i">That's the purpose of Implant Risk Radar™.</p>
        </div>

        <SectionCta label="I want access to the complete system" tone="dark" data-id="element-341" data-mp="3ndryr0lbakqw" />
      </div>
    </section>;
}